module.exports = __webpack_public_path__ + "static/media/logo_wbs_gruppe.14a15b9d.svg";